export default function (staff) {
  return {
    id: staff.id,
    title: staff.name,
    subtitle: staff.email,
    url: null,
    editor: 'entity',
    type: 'staff',
    image: {
      src: staff.avatarUrl,
      alt: staff.name,
    },
    icon: {
      name: 'person',
    },
    chips: [],
  };
}
